import { useAsyncDialog } from "../../sharedComponents/useAsyncDialog";
import { YearDialog } from "../../components/downloadFileButton/DownloadPdfButtonWithYear";

export function useSelectYearDialog() {
  return useAsyncDialog<number>(({ onAccept, onCancel }) => (
    <YearDialog open={true} onSelect={async (year) => onAccept(year)} onCancel={onCancel} />
  ));
}
